




































import { Component, Vue, Watch } from 'vue-property-decorator';
import { namespace, Getter } from 'vuex-class';
import layout from '@/layouts/app-layout.vue';
import breadcrumb from '@/components/breadcrumb.vue';
import enquiryList from '@/components/enquiry-list.vue';
import { EnquiryApi } from '@/api/enquiry-api';
import { ActionConstants } from '@/stores/enquiries/action-constants';
import Enquiry from '@/pages/enquiry.vue';
import { User } from '@/models/user';
import debounce from 'lodash.debounce';
import { Site } from '@/models/site';
import { Customer } from '@/models/customer';

const enquiryModule = namespace('enquiry');
const userModule = namespace('user');

@Component({
    components: {
        layout,
        breadcrumb,
        enquiryList,
    },
})
export default class MyEnquiries extends Vue {
    public isLoading: boolean = true;
    @enquiryModule.Getter('myEnquiriesTotalPages') public totalPages: number;
    @enquiryModule.Getter('myEnquiriesPageSize') public currentPageSize: number;
    @enquiryModule.Getter('myEnquiriesTotal') public totalEnquiries: number;
    @enquiryModule.Getter('myEnquiries') public enquiries: Array<Enquiry>;
    @enquiryModule.Getter('myEnquiriesPage') public currentPage: number;
    @enquiryModule.Getter('myEnquiriesKeyword') public keyword: string | null;
    @enquiryModule.Getter('myEnquiriesFilterStatus') public filterStatus: Array<Enquiry>;
    @enquiryModule.Getter('myEnquiriesFrom') public from: string | null;
    @enquiryModule.Getter('myEnquiriesTo') public to: string | null;
    @userModule.Getter public user: User | null;
    @userModule.Getter('currentCustomer') public currentCustomer: Customer | null;
    @userModule.Getter('currentSite') public currentSite: Site | null;

    @Watch('currentCustomer')
    public async onCustomerChanged(value: Customer): Promise<void> {
        await this.$store.dispatch(ActionConstants.fetchForUserAsync, { userId: this.user!.id!, filters: { keyword: this.keyword, status: this.filterStatus, page: this.currentPage, pageSize: this.currentPageSize, from: this.from, to: this.to } });
    }
    @Watch('currentSite')
    public async onSiteChanged(value: Site): Promise<void> {
        await this.$store.dispatch(ActionConstants.fetchForUserAsync, { userId: this.user!.id!, filters: { keyword: this.keyword, status: this.filterStatus, page: this.currentPage, pageSize: this.currentPageSize, from: this.from, to: this.to } });
    }
    public async handlePageChanged(value: number): Promise<void> {
        this.isLoading = true;

        await this.$store.dispatch(ActionConstants.updateMyEnquiriesPage, value);
        await this.$store.dispatch(ActionConstants.fetchForUserAsync, { userId: this.user!.id!, filters: { keyword: this.keyword, status: this.filterStatus, page: this.currentPage, pageSize: this.currentPageSize, from: this.from, to: this.to } });

        this.isLoading = false;
    }
    public async handlePageSizeChanged(value: number): Promise<void> {
        this.isLoading = true;

        await this.$store.dispatch(ActionConstants.updateMyEnquiriesPageSize, value);
        await this.$store.dispatch(ActionConstants.fetchForUserAsync, { userId: this.user!.id!, filters: { keyword: this.keyword, status: this.filterStatus, page: this.currentPage, pageSize: this.currentPageSize, from: this.from, to: this.to } });

        this.isLoading = false;
    }
    public handleKeywordChanged = debounce(this.handleKeywordChangedInternal, 750);
    public async handleKeywordChangedInternal(value: string | null): Promise<void> {
        this.isLoading = true;

        await this.$store.dispatch(ActionConstants.updateMyEnquiriesKeyword, value);
        await this.$store.dispatch(ActionConstants.updateMyEnquiriesPage, 1);
        await this.$store.dispatch(ActionConstants.fetchForUserAsync, { userId: this.user!.id!, filters: { keyword: this.keyword, status: this.filterStatus, page: this.currentPage, pageSize: this.currentPageSize, from: this.from, to: this.to } });

        this.isLoading = false;
    }
    public async handleStatusChanged(value: number | string | null): Promise<void> {
        this.isLoading = true;

        await this.$store.dispatch(ActionConstants.updateMyEnquiriesFilterStatus, value);
        await this.$store.dispatch(ActionConstants.updateMyEnquiriesPage, 1);
        await this.$store.dispatch(ActionConstants.fetchForUserAsync, { userId: this.user!.id!, filters: { keyword: this.keyword, status: this.filterStatus, page: this.currentPage, pageSize: this.currentPageSize, from: this.from, to: this.to } });

        this.isLoading = false;
    }
    public async handleFromChanged(value: string | null): Promise<void> {
        this.isLoading = true;

        await this.$store.dispatch(ActionConstants.updateMyEnquiriesFrom, value);
        await this.$store.dispatch(ActionConstants.updateMyEnquiriesPage, 1);
        await this.$store.dispatch(ActionConstants.fetchForUserAsync, { userId: this.user!.id!, filters: { keyword: this.keyword, status: this.filterStatus, page: this.currentPage, pageSize: this.currentPageSize, from: this.from, to: this.to } });

        this.isLoading = false;
    }
    public async handleToChanged(value: string | null): Promise<void> {
        this.isLoading = true;

        await this.$store.dispatch(ActionConstants.updateMyEnquiriesTo, value);
        await this.$store.dispatch(ActionConstants.updateMyEnquiriesPage, 1);
        await this.$store.dispatch(ActionConstants.fetchForUserAsync, { userId: this.user!.id!, filters: { keyword: this.keyword, status: this.filterStatus, page: this.currentPage, pageSize: this.currentPageSize, from: this.from, to: this.to } });

        this.isLoading = false;
    }

    public async mounted(): Promise<void> {
        this.isLoading = true;
        await this.$store.dispatch(ActionConstants.updateMyEnquiriesPage, 1);
        await this.$store.dispatch(ActionConstants.fetchForUserAsync, { userId: this.user!.id!, filters: { keyword: this.keyword, status: this.filterStatus, page: this.currentPage, pageSize: this.currentPageSize, from: this.from, to: this.to } });
        this.isLoading = false;
    }
}
